import * as actionType from './../constants/ActionTypes';
import AppConfig from '../../../App.config.ts';
import Components from '../../../constants/Components';
import Logger from 'neon-frontend-utils/src/logger';
import Utils from 'neon-frontend-utils/src/utils';

const languageConfig = AppConfig.languages;
const browserLanguage = Utils.getBrowserLanguage(
    languageConfig.supported,
    languageConfig.defaultLanguage,
    languageConfig.mapped
);

const initialState = {
    languageId: localStorage.getItem('languageId')
        ? JSON.parse(localStorage.getItem('languageId'))
        : browserLanguage || AppConfig.languages.defaultLanguage,
    participationLanguageId: null
};

/**
 * Returns the new state
 * @param {Object} state - state
 * @param {Object} action - action
 * @returns {Object} new state
 */
export default function languageReducer(state = initialState, action) {
    const newState = Object.assign({}, state);

    switch (action.type) {
        case actionType.SET_LANGUAGE:
            try {
                newState.languageId = action.languageId;
            } catch (error) {
                Logger.instance.error({
                    message: 'Exception in languageReducer SET_LANGUAGE',
                    component: Components.SET_LANGUAGE,
                    error
                });
            }

            break;

        case actionType.SET_PARTICIPATION_LANGUAGE:
            try {
                newState.participationLanguageId = Utils.convertParticipantLanguage(action.languageId);
            } catch (error) {
                Logger.instance.error({
                    message: 'Exception in languageReducer SET_PARTICIPATION_LANGUAGE',
                    component: Components.SET_LANGUAGE,
                    error
                });
            }

            break;

        default:
            return state;
    }

    return newState;
}
